// FNP-802: form-shape Zod schema for a BillableUnit.
import {z} from 'zod';

export const RecordSchema = z.object({
    name: z.string().min(1, 'Required'),
    meterId: z.string().min(1, 'Required'),
    // The conversion factor is a money-path value: it says how many METERED units make
    // ONE billable unit. Guard the two ways it can be wrong at the form boundary —
    // zero/negative (nonsensical) and fractional (invites float drift on a charge).
    meteredUnitsPerBillableUnit: z
        .number({invalid_type_error: 'Must be a number'})
        .int('Must be a whole number')
        .positive('Must be greater than zero')
        // nullish, not optional: the API stores an absent factor as null (meaning 1:1),
        // and .optional() rejects that null when an existing record is edited.
        .nullish(),
});
